import React, { useState } from 'react';
import styles from "./ReviewIndividualApplication.module.scss";
import {useSelector, useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button} from "@onegovbugs/onegov-react-components";
import { ImportExportDetailsReviewUnit } from '../../../components/importExport/reviewApplication/ImportExportDetailsReviewUnit';
import { LicenceInformationReviewUnit } from '../../../components/importExport/reviewApplication/LicenceInformationReviewUnit';
import { InterStateDecisionReviewUnit } from '../../../components/importExport/reviewApplication/InterStateDecisionReviewUnit';
import { InterStateContactDetailsReviewUnit } from 'components/importExport/reviewApplication/InterStateContactDetailsReviewUnit';
import { SpeciesDetailsReviewUnit } from 'components/importExport/reviewApplication/SpeciesDetailsReviewUnit';
import { ApplicantDetailReviewUnit } from 'components/importExport/reviewApplication/ApplicantDetailReviewUnit';
import { AttachmentReviewUnit } from 'components/importExport/reviewApplication/AttachmentDetailReviewUnit';
import {saveImportExportApplication} from "../../../redux/actions";


const ReviewIndividualApplication = props => {

  const dispatch = useDispatch();
  const importExportDetails = useSelector(state => state.importExportDetails);
  const licenceDetails = useSelector(state => state.licenceDetails);
  const interStateDetails = useSelector(state => state.interStateDetails);
  const speciesDetails = useSelector(state => state.speciesDetails);
  const twoFA = useSelector((state) => state.twoFA);
  const personalDetails = useSelector(state => state.personalDetails);
  const attachmentDetails = useSelector(state => state.attachmentDetails);
  const [twoFAData] = useState(twoFA ? twoFA.data : {firstName:"",lastName:"",day:"",month:"",year:""});

    return <div className={styles.mainCont}>
      <p>
        Please check the information you have entered in this application. If
        you need to correct any of the details, click 'Back' or select the
        relevant section and change the information as appropriate. To proceed
        with the application click 'Next'.
      </p>
    
      <ImportExportDetailsReviewUnit importExportDetails={importExportDetails}/>
      <LicenceInformationReviewUnit licenceDetails={licenceDetails} props={props}/>
      <ApplicantDetailReviewUnit 
          personalDetails={personalDetails} 
          twoFAData = {twoFAData} 
          onEditUrl ={"/import-export/applicant-details"}
          props = {props} 
          title = {'Applicant Details'}
          type = {'Individual'}
        />      

      <InterStateDecisionReviewUnit 
        importExportDetails={importExportDetails} 
        props={props} 
        onEditUrl={'/import-export/individual-interstate-decision'}  
      />

      <InterStateContactDetailsReviewUnit
          interStateDetails = {interStateDetails} 
          props={props}
          title= {`Interstate Person/Organisation Details`}
          onEditUrl={'/import-export/interstate-individual'}
          interStateType = {importExportDetails.interStateDecisionAppType}
      />     

      <SpeciesDetailsReviewUnit speciesDetails={speciesDetails} props={props} onEditUrl={'/import-export/interstate-individual-licence'}/>

      <AttachmentReviewUnit
        attachmentDetails={attachmentDetails}
        onEditUrl={'/import-export/upload-document'}
        props={props}
      />

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              props.history.push(`./individual-declaration`);
            }}
          >
            Confirm
          </Button>
          <Button
          secondary
          onClick={() => {
            dispatch(
              saveImportExportApplication("", () => {
                  props.history.push(`./dashboard`);
              })
            ); 
          }}
        >
          Save & exit section
        </Button>
        </div>
      </div>

    </div>
  };
  
  export default withRouter(props => <ReviewIndividualApplication {...props}/>);
  
